import $ from 'jquery'

const initializeBlock = function ($block) {
  const wrapper = $block.find('.screen-capture-block__image-wrapper')
  const img = wrapper.find('img')
  const button = $block.find('.vn-button')
  const height = wrapper.height()
  let active = false

  button.on('click', function () {
    $block.toggleClass('screen-capture-block--active')
    active = !active

    wrapper.animate({ height: active ? img.height() + 40 : height })
  })
}

$('.screen-capture-block').each(function () {
  initializeBlock($(this))
})

if (window.acf) {
  window.acf.addAction(
    'render_block_preview/type=vn-screen-capture',
    initializeBlock
  )
}
